$(() => {
  // submit the client-picker form when a client is chosen. Previously an inline
  // onchange="this.form.submit();" attribute; moved here so it satisfies the
  // script-src-attr 'self' CSP directive instead of tripping a violation.
  $('#nav-client-select select').on('change', function() {
    this.form.submit();
  });

  // the ROI Models menu is open by default after a client is picked - close it if we're not on one of its pages
  if ($('a[href="#roi-models-menu"]').find('.active').length === 0) {
    $(this).removeClass('show');
  }

  // open the appropriate calculator nav menu
  $('.nav-item .active').closest('.collapse').addClass('show');

  // update the state of the navbar menu arrows as appropriate
  $('a[aria-expanded]').each(function() {
    if ($(this).closest('.nav-item').find('.active').length > 0) {
      $(this).attr('aria-expanded', 'true');
    }
  });

  // pass the calculator path to the form for starting the session and clear the info from the previous prospect
  $('a[data-target="#start-calculator-session-modal"]').click(function() {
    $('#start-calculator-session-form input[type="text"]').val('');
    $('#start-calculator-session-form input[name="path"]').val($(this).data('path'));

    const rg_pricing_optional = $(this).data('repGuidedPricingOptional');
    const rg_pricing_default_on = $(this).data('repGuidedPricingDefaultOn');

    if (rg_pricing_optional === true) {
      $('.hide-pricing-row').slideDown(0);

      if (!rg_pricing_default_on) {
        $('#start-hide-pricing').attr('checked', 'checked');
      }
    } else {
      $('.hide-pricing-row').slideUp(0);
    }

    const salesforce_opportunity_id_required = $(this).data('salesforceOpportunityIdRequired');

    if (salesforce_opportunity_id_required === true) {
      $('#salesforce_opportunity_id').removeClass('optional');
      $('#salesforce_opportunity_id').data('validate-format', '18-chars');
    } else {
      $('#salesforce_opportunity_id').addClass('optional');
      $('#salesforce_opportunity_id').data('validate-format', '');
    }

    return true;
  });

  // validate the form for starting the session, and close the modal on success
  $('#start-calculator-session-form').submit(function() {
    $(this).find('input').each(function() {
      const $container = $(this).closest('.float-label-container');
      const $label = $container.find('label');
      const $feedback = $container.find('.invalid-feedback');

      // Skip optional inputs
      if ($(this).hasClass('optional')) { return true; }

      // Check for empty value
      if ($(this).val().length === 0) {
        $container.addClass('is-invalid');
        $label.addClass('text-danger');
        return true;
      }

      // Check for 18-chars format validation
      if ($(this).data('validate-format') === '18-chars') {
        const isValid18Chars = /^[a-zA-Z0-9]{18}$/.test($(this).val());
        if (!isValid18Chars) {
          $container.addClass('is-invalid');
          $label.addClass('text-danger');
          $feedback.show();
          return true;
        }
      }

      $container.removeClass('is-invalid');
      $label.removeClass('text-danger');
      $feedback.hide();
    });

    if ($(this).find('.is-invalid').length > 0) { return false; }
    $('#start-calculator-session-modal').modal('hide');
    return true;
  });

  // clear any error classes as the user goes
  $('#start-calculator-session-form input').blur(function() {
    if ($(this).val().length > 0) {
      const $container = $(this).closest('.float-label-container');
      const $label = $container.find('label');
      $container.removeClass('is-invalid');
      $label.removeClass('text-danger');
    }
  });
});
